'use client'

import NextLink from '@/components/NextLink';
import Button from '@/components/ui/Button';
import Image from 'next/image';

export default function BrokenPage() {

    return (
        <div className=' min-h-dvh md:min-h-full h-full px-4 w-full flex items-center justify-center md:justify-start flex-col'>
            <Image width={400} height={400} alt='404' src={`${process.env.NEXT_PUBLIC_STORAGE_URL}image/5b251b78-c3d5-4252-895a-1e70fffb9a6b-planingo.png`} />
            <h1 className='text-lg md:text-2xl font-semibold md:font-bold mt-10 md:mt-12'>Our servers need a quick coffee break ☕</h1>
            <p className='mt-2 text-sm md:text-base font-normal text-gray-500 text-center'>We’re working to fix this issue. Please try again later or contact support if the problem persists.</p>
            <div className='flex items-center justify-center mt-6 gap-6'>
                <NextLink href='/'>
                    <Button color='ghostIndigo' >
                        Go Home
                    </Button>
                </NextLink>
                <Button color='primary' onClick={() => window.location.reload()} >
                    Try Again
                </Button>
            </div>
        </div>
    )
}